







import Vue from 'vue';
import { default as Component } from 'vue-class-component';

import SERVICES from '@/container/Services';
import IocContainer from '@/container/IocContainer';

import Language from '@/interfaces/Language';
interface Message {
  key: string;
  message: string;
}

const langProvider = IocContainer.get<Language>(SERVICES.LANGUAGE);

@Component({
  props: {
    success: {
      type: Array,
      default: () => []
    },
    errors: {
      type: Array,
      default: () => []
    },
    date: {
      type: Boolean,
      default: false
    }
  }
})
export default class MessagesBlock extends Vue {
  get isSuccess(): boolean {
    return this.$props.success !== null && this.$props.success.length > 0 && typeof this.$props.success[0] === 'object';
  }

  get messages(): [] {
    return this.isSuccess ? this.$props.success : this.$props.errors;
  }

  get classObject(): { 'messages-form-success': boolean; 'messages-form-error': boolean } {
    return {
      'messages-form-success': this.isSuccess,
      'messages-form-error': !this.isSuccess
    };
  }

  protected trans(message: Message | string): string {
    if (typeof message === 'string') {
      return message;
    }
    return langProvider.has(message.key) ? langProvider.trans(message.key) : message.message;
  }
}
